const { createImage, duplicateImage } = require('./Image');
const { duplicateQuirk } = require('./Quirk');
const { duplicateTrait } = require('./Trait');
const Misc = require('../constants/misc');

const baseSpecies = {
  _version: 7,
  uid: '',
  name: '',
  displayName: '',
  description: '',
  tier: Misc.STARTING_TIER,
  homeworld: '',
  traits: [],
  quirks: [],
  player: '',
  image: createImage(),
  created: '',
  updated: '',
  preContact: '' // uuid
};

const createSpecies = (overrides = {}) => {
  return { ...baseSpecies, ...overrides };
}

const duplicateSpecies = species => ({
  ...species,
  traits: species.traits.map(duplicateTrait),
  quirks: species.quirks.map(duplicateQuirk),
  image: duplicateImage(species.image)
});

module.exports = {
  createSpecies,
  duplicateSpecies
};
